import React, { useMemo } from 'react';
import styles from '../AccessDenied/AccessDenied.module.css';
import { useAppConfig } from '../../context/AppConfigContext';
import { useAuth } from '../../context/AuthContext';

const LOCAL_INFO_VARIANTS = {
  ru: [
    'Время на распознавание аудио закончилось. Попробуйте позже или активируйте Premium.',
    'Лимит распознавания речи исчерпан. Он восполняется каждые 3 часа. Больше времени в Premium.',
    'Сейчас лимит аудио закончился. Вернитесь позже или активируйте Premium для продолжения.',
  ],
  uk: [
    'Час на розпізнавання аудіо закінчився. Спробуйте пізніше або активуйте Premium.',
    'Ліміт розпізнавання мовлення вичерпано. Він поповнюється кожні 3 години. Більше часу у Premium.',
    'Зараз ліміт аудіо вичерпано. Поверніться пізніше або активуйте Premium для продовження.',
  ],
  en: [
    'Your audio recognition time is over. Try again later or activate Premium.',
    'Speech recognition limit is used up. It refreshes every 3 hours. Get more time with Premium.',
    'Audio limit is reached right now. Come back later or activate Premium to continue.',
  ],
  de: [
    'Deine Zeit fur die Audioerkennung ist abgelaufen. Versuche es spater oder aktiviere Premium.',
    'Dein Spracherkennungslimit ist aufgebraucht. Es wird alle 3 Stunden erneuert. Mehr Zeit gibt es mit Premium.',
    'Audio-Limit erreicht. Komm spater wieder oder nutze Premium, um weiterzumachen.',
  ],
};

const normalizeLang = (lang) => {
  const safe = String(lang || '').trim().toLowerCase();
  if (safe === 'ua') return 'uk';
  if (safe === 'ru' || safe === 'uk' || safe === 'en' || safe === 'de') return safe;
  return 'ru';
};

const pickRandom = (items) => {
  if (!Array.isArray(items) || items.length === 0) return '';
  const index = Math.floor(Math.random() * items.length);
  return items[index];
};

const AudioTimeEnded = ({ onBack, onGoPremium = null }) => {
  const { t, baseLanguage } = useAppConfig();
  const { isGuest: temp } = useAuth();
  const lang = normalizeLang(baseLanguage);
  const premiumButtonText = t.audioTimeEnded?.premiumButton || t.menu?.buyPremium || 'Premium';

  const infoText = useMemo(() => {
    const configVariants = Array.isArray(t?.audioTimeEnded?.infoVariants)
      ? t.audioTimeEnded.infoVariants.filter((item) => String(item || '').trim())
      : [];

    const configSingle = String(t?.audioTimeEnded?.info || '').trim();
    const localVariants = LOCAL_INFO_VARIANTS[lang] || LOCAL_INFO_VARIANTS.ru;

    const variants = [
      ...configVariants,
      ...(configSingle ? [configSingle] : []),
      ...localVariants,
    ];

    const unique = Array.from(new Set(variants));
    return pickRandom(unique) || LOCAL_INFO_VARIANTS.ru[0];
  }, [lang, t?.audioTimeEnded]);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>{t.audioTimeEnded?.title || 'Время закончилось'}</h2>
        <p className={styles.text}>{infoText}</p>
        {temp && <p className={styles.tempNote}>{t.accessDenied.tempUser}</p>}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
          <button className={styles.button} onClick={onBack}>
            {t.audioTimeEnded?.backButton || 'Назад'}
          </button>
          {typeof onGoPremium === 'function' && (
            <button className={styles.button} onClick={onGoPremium}>
              {premiumButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AudioTimeEnded;
